// extracted by mini-css-extract-plugin
export default {"PopUpLayout":"styles_PopUpLayout__Nl5s-"};